import { User } from '../../app/store/types/auth.types';
import { Client } from '../../pages/dashboard/Clients/types';

export const validateAuthentication = (user: User | null, client?: Client): boolean => {
  if (client?.isPublic) return true;
  return !!user;
};
